/**
 *  slot： 自设样式；
 *  props:   showImg: 选择图片后显示图片
 *  选择图片后 emit("loaded",{file,base64})
 */
<template>
  <div class="uploadImg">
    <slot></slot>
    <img class="img" :src="getImgUrl(base64)" alt v-if="showImg && innerBase64">
    <input class="inputBt" type="file" accept="image/*" @change="selectedImg">
  </div>
</template>
<script>
import { UPLOAD } from "@/assets/configs/api/yuanqu"
export default {
  name: "uploadImg",
  data() {
    return {
      file: null,
      innerBase64:null
    };
  },
  props: {
    showImg: {
      type: Boolean,
      default: false
    },
    base64:{
    	type:String,
    	default: null
    }
  },
  watch : {
  	base64 ( val ) {
  		this.innerBase64 = val
  	}
  },
  methods: {
  	getImgUrl(imgUrl){
  		var t = new Date().getTime()
  		return imgUrl + `?t=${t}`
  	},
  	upload (file) {
  		let config = {
  			headers: {
  				"Content-Type": "multipart/form-data"
  			}
  		}
  		let param = new FormData(); //创建form对象
        param.append('imgFiles', file);
  		this.$post(UPLOAD,
			param,
			data => {
				this.innerBase64 = data[0]
				this.$emit("loaded", {
		          file: this.file,
		          base64: data[0]
		        })
			},
	        error => {
	        	
	        },config
      	)
  	},
    selectedImg(event) {
      this.file = event.target.files[0]
      this.upload(event.target.files[0])
   }
}
};
</script>
<style lang="scss" scoped>
.uploadImg {
  position: relative;
  .inputBt {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    z-index: 99;
  }
  .img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>


